import React, { useState } from "react";
import GrafanaHOC from "./GrafanaHOC";
import styles from "./styles.module.css";
import { Button, Modal } from "antd";
import { GrafanaDataType } from "./GrafanaFunctions";

interface GrafanaPageProps {
  createToken: () => void;
  isUpdating: boolean;
  data: GrafanaDataType | undefined;
  deleteToken: () => void;
}

function GrafanaPage({
  createToken,
  isUpdating,
  data,
  deleteToken,
}: GrafanaPageProps) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showDeleteConfirmation = () => {
    setIsModalVisible(true);
  };

  const handleDeleteConfirm = () => {
    deleteToken();
    setIsModalVisible(false);
  };

  const handleDeleteCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.styled_div}>
          {data && data.orgName && data.orgId ? (
            <>
              <h3>Grafana Information</h3>
              <div>
                <b>Organization Name:</b> {data.orgName}
              </div>
              <div>
                <b>Organization ID:</b> {data.orgId}
              </div>
              <Button
                style={{
                  marginTop: "10px",
                }}
                type="default"
                danger
                onClick={showDeleteConfirmation}
                loading={isUpdating}
                disabled={isUpdating}
              >
                Remove Grafana
              </Button>
            </>
          ) : (
            <>
              <h3>This account does not have Grafana</h3>
              <Button
                type="primary"
                onClick={createToken}
                loading={isUpdating}
                disabled={isUpdating}
              >
                Add Grafana
              </Button>
            </>
          )}
        </div>
      </div>
      <Modal
        title="Delete Token Confirmation"
        open={isModalVisible}
        onOk={handleDeleteConfirm}
        onCancel={handleDeleteCancel}
        okText="Remove"
        cancelText="Cancel"
        okButtonProps={{
          danger: true,
          loading: isUpdating,
          disabled: isUpdating,
        }}
        cancelButtonProps={{ disabled: isUpdating }}
      >
        <p>Are you sure you want to remove Grafana from this account?</p>
      </Modal>
    </>
  );
}

export default GrafanaHOC(GrafanaPage);
